import { FolderItemORM } from 'src/types/types'
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types'
import { useEffect } from 'react'

// Not implemented
const DNADocumentVersionSearchRow: DNARowsComponent<FolderItemORM> = () => {
  useEffect(() => {
    console.error('DNADocumentVersionSearchRow not implemented yet')
  }, [])

  return (null)
}

export default DNADocumentVersionSearchRow
